import { CommonActionRequestType, RequestType } from '../reducers/requestReducer';
import { RequestActionType } from './requestActions';

export enum InitActionTypes {
    InitializeInit = 'INITIALIZE/INIT',
    ChangeLanguage = 'USER_CHANGE_LANGUAGE',
}

export interface Initialize extends CommonActionRequestType {
    type: InitActionTypes.InitializeInit;
}

export const initialize = (): Initialize => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.Initialize,
    type: InitActionTypes.InitializeInit,
});

export interface ChangeLanguage {
    type: InitActionTypes.ChangeLanguage;
    language: string;
}

export const changeLanguage = (language: string): ChangeLanguage => ({
    type: InitActionTypes.ChangeLanguage,
    language,
});
